<template>
    <div class="print:hidden">
        <div v-show="!done">
            <intake-layout :page="step" @goto="navigateStep">
                <component :is="forms[step]" :series="series" @goto="navigateStep" @prev="handlePrev" @next="handleNext" @process="handleProcess" @complete="handleDone"></component>
            </intake-layout>
        </div>
        <div v-show="done">
            <div class="flex items-center justify-center min-h-screen bg-center bg-no-repeat bg-cover" :style="'background-image: url(' + asset('img/thanks-bg.jpg') + ')'">
                <div class="w-full max-w-4xl px-6 text-center">
                    <h2 class="text-6xl font-bold no-underline normal-case mb-9 non-italic">Thank You For Signing Up!</h2>
                    <h4 class="mb-12 text-2xl font-bold text-center no-underline capitalize non-italic">We will follow up shortly.</h4>

                    <Link :href="route('index')" class="inline-flex pb-1 text-2xl font-bold text-black border-b-2 border-black animate-bounce hover:border-teal">
                        <span>Review Your Profile</span>
                        <svg class="w-6 h-6 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                    </Link>
                </div>
            </div>
        </div>

        <app-modal :show="isBusy" :closeable="false" class="sm:max-w-sm">
            <div class="text-center">
                <h3 class="text-sm tracking-widest text-white uppercase">Processing...</h3>
                <svg class="w-10 h-10 mx-auto mt-2 animate-spin text-teal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
            </div>
        </app-modal>
    </div>
</template>

<script>
import IntakeLayout from '@/Layouts/Intake'
import AppButton from '@Components/Button'
import AppModal from '@Components/Modal'
import ProfileForm from '@/Pages/Intake/ProfileForm'
import SuitabilityForm from '@/Pages/Intake/SuitabilityForm'
import InvestForm from '@/Pages/Intake/InvestForm'
import VerificationForm from '@/Pages/Intake/VerificationForm'
import AgreementForm from '@/Pages/Intake/AgreementForm'
import ReviewForm from '@/Pages/Intake/ReviewForm'
import ConfirmationForm from '@/Pages/Intake/ConfirmationForm'
import { useStore } from 'vuex'
import { computed, onBeforeMount, ref } from 'vue'
import { usePage, Link } from '@inertiajs/inertia-vue3'
import { useUrlSearchParams } from '@vueuse/core'

export default {
    components: {
        IntakeLayout,
        AppButton,
        AppModal,
        ProfileForm,
        SuitabilityForm,
        InvestForm,
        VerificationForm,
        AgreementForm,
        ReviewForm,
        ConfirmationForm,
        Link
    },
    props: {
        intake: {
            type: Object,
            default: () => ({})
        },
        start: {
            type: Number,
            default: 0
        },
        series: {
            type: String,
            default: 'default'
        }
    },
    setup(props){
        const store  = useStore()
        const forms  = ['profile-form', 'suitability-form', 'invest-form', 'verification-form', 'review-form', 'confirmation-form']
        const step   = ref(0);
        const done   = ref(false)
        const isBusy = ref(false)

        const isUserActivated = computed(() => {
            const user = _.get(usePage().props.value, 'auth.user')

            return user.activated && user.account_id != ''
        })

        onBeforeMount(() => {
            _.each(['profile-form', 'suitability-form', 'invest-form', 'verification-form'], (form) => {
                const formKey = _.camelCase(form)
                const formData = _.get(props.intake, formKey, {});

                store.commit('UPDATE_FORM_DATA', {
                    form: formKey,
                    data: formData
                });
            })

            const params = useUrlSearchParams('history')

            if (_.has(params, 'step') && isUserActivated.value) {
                step.value = params.step
            } else {
                step.value = props.start
            }
            //step.value = 5
        })

        function navigateStep(index){
            step.value = index;
        }

        function handlePrev(index){
            if (step.value > 0) {
                step.value--
            }
        }

        function handleNext(index){
            if (step.value < forms.length) {
                step.value++
            }
        }

        function handleProcess(){

        }

        async function handleComplete(){
            isBusy.value = true

            // # create contact in hubspot
            console.log('CREATING HUBSPOT CONTACT..')
            await axios.post(route('api.hubspot.create-contact'), {
                firstname: _.get(store.state.profileForm, 'primary.firstName'),
                lastname: _.get(store.state.profileForm, 'primary.lastName'),
                email: _.get(store.state.profileForm, 'primary.email')
            }).then(response => {
                if (response.status == 200) {
                    console.log(response.data)
                    console.log('CREATED HUBSPOT CONTACT..')
                }
            }).catch(error => {
                console.log(error.response)
            })
        }

        function handleDone(){
            window.location.href = route('index')
        }

        return {
            forms,
            step,
            done,
            isBusy,
            isUserActivated,
            navigateStep,
            handlePrev,
            handleNext,
            handleProcess,
            handleComplete,
            handleDone
        }
    }
}
</script>

<style>

</style>
